import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-modal": "true",
  class: "wrapper"
}
const _hoisted_2 = { class: "close-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "toast"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onclick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = { class: "p-input-icon-right" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "char-count" }
const _hoisted_13 = {
  class: "buttons",
  style: {flexDirection: 'row', marginBottom: '4rem'}
}

import {
  ref,
  onUpdated,
} from "vue";
import CloseGreyIcon from "../assets/images/Close-grey.svg";
import CloseCircle from "../assets/images/CloseCircle.svg";
import CloseIcon from "../assets/images/Close.svg";
import InfoAlertIcon from "../assets/images/InfoAlertRed.svg";
import { limitCharacter } from "../assets/helpers";
import store from "@/store";
import { SessionWithOrdersAndType } from "@/types/session-interfaces";
import { FolderWithSessions } from "@/types/folder-interfaces";

interface FilterKeyEvent extends KeyboardEvent {
  target: HTMLInputElement;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TitleChangeModal',
  props: {
  itemTitle: {
    type: String,
    required: true,
  },
  itemId: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
  setVisible: {
    type: Function,
    required: true,
  },
  itemType: {
    type: String,
    default: 'session',
  },
},
  emits: ["updateTitleSuccessful"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const newTitle = ref(props.itemTitle),
      loading = ref(false),
      showClear = ref(false),
      showToast = ref(false);

function filterKey(event: FilterKeyEvent) {
  limitCharacter(event, event.target.value);
}

async function changeTitle() {
  newTitle.value = newTitle.value.trim();
  if (newTitle.value === props.itemTitle || newTitle.value === "" ) {
    props.setVisible(false);
    return;
  }

  loading.value = true;

  const updateData: Partial<SessionWithOrdersAndType | FolderWithSessions> = {
    title: newTitle.value,
  };

  const payload = {
    id: props.itemId,
    updates: updateData
  }

  await store.dispatch('itemList/updateItem', payload)
    .then(() => {
      props.setVisible(false);
      showClear.value = false;
      loading.value = false;
      showToast.value = false;
      store.dispatch('itemList/clearSelection');
      emit("updateTitleSuccessful", newTitle.value);
    })
    .catch(() => {
      showToast.value = true;
      loading.value = false;
    });
}

function close() {
  props.setVisible(false);
}

function delayRemove() {
  // TODO: come up with something better
  setTimeout( () => showClear.value = false, 250)
}

function setShowToast(visible: boolean) {
  showToast.value = visible;
}

onUpdated (() => {
  newTitle.value = props.itemTitle;
})

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    class: "dialog",
    closable: true,
    modal: true,
    "aria-label": ' Edit ' + props.itemType + ' title',
    "aria-expanded": __props.visible,
    "close-on-escape": true
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            "aria-label": "Close menu",
            class: "close",
            onclick: close,
            onKeydown: _cache[0] || (_cache[0] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              close();
            }
          })
          }, [
            _createElementVNode("img", {
              role: "presentation",
              src: _unref(CloseGreyIcon),
              alt: "Close menu"
            }, null, 8, _hoisted_3)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_4, " Edit " + _toDisplayString(props.itemType) + " title ", 1),
        (showToast.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "toast-bar" }, null, -1)),
              _createElementVNode("img", {
                src: _unref(InfoAlertIcon),
                alt: "Alert",
                style: {width: '2.4rem', height: '2.4rem', margin: '0'}
              }, null, 8, _hoisted_6),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "toast-text" }, " Oops! Something went wrong. Please try again later. ", -1)),
              _createElementVNode("button", {
                "aria-label": "Close menu",
                class: "toast-icon",
                onclick: setShowToast(false),
                onKeydown: _cache[1] || (_cache[1] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              setShowToast(false);
            }
          })
              }, [
                _createElementVNode("img", {
                  role: "presentation",
                  src: _unref(CloseIcon),
                  alt: "Close menu"
                }, null, 8, _hoisted_8)
              ], 40, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_InputText, {
              "aria-label": 'Edit title',
              autofocus: "true",
              id: "newTitle",
              modelValue: newTitle.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newTitle).value = $event)),
              class: "input",
              onKeydown: filterKey,
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (showClear.value = true)),
              onBlur: delayRemove
            }, null, 8, ["modelValue"]),
            (newTitle.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (newTitle.value = '')),
                  onKeydown: _cache[5] || (_cache[5] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                newTitle.value = '';
              }
            }),
                  "aria-label": "Clear input",
                  src: _unref(CloseCircle),
                  alt: "Clear input",
                  class: "clear-icon"
                }, null, 40, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(newTitle.value.length) + " / 50 ", 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Button, {
            "aria-label": "Cancel",
            onKeydown: _cache[6] || (_cache[6] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              close();
            }
          }),
            onClick: close,
            class: "buttons-button buttons-cancel"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Cancel ")
            ])),
            _: 1,
            __: [10]
          }),
          _createVNode(_component_Button, {
            "aria-label": "Save",
            onKeydown: _cache[7] || (_cache[7] = ($event) => {
            if ($event.key === 'Enter') {
              $event.preventDefault();
              changeTitle();
            }
          }),
            onClick: changeTitle,
            class: "buttons-button buttons-save"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Save ")
            ])),
            _: 1,
            __: [11]
          })
        ])
      ])), [
        [_directive_focustrap]
      ])
    ]),
    _: 1
  }, 8, ["visible", "aria-label", "aria-expanded"]))
}
}

})